import { useContext } from "react";

import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";

import FilterButton from "components/Filters/components/FilterButton";
import FilterMenu from "components/Filters/components/FilterMenu";
import { useFilters } from "components/Filters/hooks";
import TableContext from "context/table/tableContext";
import {
    filterDropdownCustomMargin,
    generalFiltersBlockStyle,
    useMediaQueries
} from "shared";

import AllPermissions from "./AllPermissions";
import Status from "./Status";

export const PermissionFilters = () => {
    const { hasNoPermissionToRead } = useContext(TableContext);

    const { t } = useTranslation();
    const { fromLg, toLg } = useMediaQueries();
    const { anchorEl, handleOpenMenu, handleCloseMenu } = useFilters();

    return (
        <div css={css(generalFiltersBlockStyle)}>
            {fromLg && <Status customStyle={filterDropdownCustomMargin} />}

            <FilterButton
                onOpen={handleOpenMenu}
                isDisabled={hasNoPermissionToRead}
            >
                {fromLg ? t("Button##more filters") : t("Button##filters")}
            </FilterButton>

            <FilterMenu
                isOpen={Boolean(anchorEl)}
                anchorEl={anchorEl}
                onClose={handleCloseMenu}
            >
                <div
                    css={css({
                        "& > div + div": {
                            marginTop: "12px"
                        }
                    })}
                >
                    {toLg && <Status />}

                    <AllPermissions />
                </div>
            </FilterMenu>
        </div>
    );
};
